'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _users = require('./users.getPresence');

var _users2 = _interopRequireDefault(_users);

var _users3 = require('./users.identity');

var _users4 = _interopRequireDefault(_users3);

var _users5 = require('./users.info');

var _users6 = _interopRequireDefault(_users5);

var _users7 = require('./users.list');

var _users8 = _interopRequireDefault(_users7);

var _users9 = require('./users.setActive');

var _users10 = _interopRequireDefault(_users9);

var _users11 = require('./users.setPresence');

var _users12 = _interopRequireDefault(_users11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  getPresence: _users2.default,
  identity: _users4.default,
  info: _users6.default,
  list: _users8.default,
  setActive: _users10.default,
  setPresence: _users12.default
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/slack/methods/users.js
// module id = 442
// module chunks = 0